import * as tslib_1 from "tslib";
import { DomSanitizer } from '@angular/platform-browser';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
import { NgbTimeConverter } from '../../common/service/ngbTimeConverter.utils';
import { DesignerCube } from './designerCube.component';
import { BiUrls } from '../../biUrls';
import { ViewContainerRef, ElementRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { MeasureData, CubeMeasure } from './service';
var POCWizard = /** @class */ (function () {
    function POCWizard(service, toaster, vcr, ngbDataConv, ngbTimeConv, _sanitizer) {
        this.service = service;
        this.toaster = toaster;
        this.vcr = vcr;
        this.ngbDataConv = ngbDataConv;
        this.ngbTimeConv = ngbTimeConv;
        this._sanitizer = _sanitizer;
        this.accessDenied = false;
        this.loader = false;
        this.cubeScreen = true;
        this.wizardScreen = false;
        this.prestoValidation = true;
        this.mapperScreen = false;
        this.measureMap = new Map();
        this.dimensionMap = new Map();
        this.dimensionPage = false;
        this.measurePage = false;
        this.editDimensionPage = false;
        this.editMeasurePage = false;
        this.uploadScreen = false;
        this.activeScreen = "upload";
        this.dataSourceList = [];
        this.dimensionList = [];
        this.typeList = ['csv', 'psv', 'tsv', 'json', 'xlsx'];
        this.saveButton = false;
        this.editScreen = false;
        this.dataVersionDate = { day: null, month: null, year: null };
        this.isEdit = false;
        this.isFormulaMeasure = false;
        this.inMesEdit = false;
        this.isnewFormulaMeasure = false;
        this.warning = "Please type to select";
        this.pageSize = 10;
        this.pageNo = 0;
        this.dropdownSettings = {
            singleSelection: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            id: 'refId',
            itemName: 'displayName',
            text: "Search Dimension",
            //itemsShowLimit: 0,
            allowSearchFilter: true,
        };
        this.dataVersionTime = { hour: null, minute: null, second: null };
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
        this.toaster.setViewRef(vcr);
    }
    POCWizard.prototype.ngOnInit = function () {
        if (!this.service.isBIAdmin) {
            this.accessDenied = true;
        }
        else {
            this.getDataSourceForDrill();
        }
    };
    POCWizard.prototype.ngOnDestroy = function () {
        // this.service.referencePage = null;
    };
    POCWizard.prototype.callToaster = function (type, msg) {
        this.toaster.setViewRef(this.vcr);
        switch (type) {
            case MDMService.ERROR:
                return this.toaster.showError(msg);
            case MDMService.SUCCESS:
                return this.toaster.showSuccess(msg);
            case MDMService.WARNING:
                return this.toaster.showWarning(msg);
        }
    };
    POCWizard.prototype.getDataSourceForDrill = function () {
        var self = this;
        self.service.getAll('ds').then(function (res) {
            self.dataSourceList = res.data != null ? res.data : [];
        });
    };
    POCWizard.prototype.selectDataSource = function (event) {
        var _this = this;
        if (event != 'none') {
            this.selectedDataSourceId = +event.target.value;
            this.dataSourceList.forEach(function (ds) {
                if (ds.id == event.target.value) {
                    _this.selectedDataSource = ds;
                }
            });
        }
    };
    POCWizard.prototype.setCubeForEdit = function (event) {
        var self = this;
        self.cubeId = event.cube.refId;
        self.isEdit = event.cube.id != undefined;
        self.analyticalModel = event;
        self.isStarSchema = event.isStarSchema;
        self.selectedType = self.isStarSchema ? 'Star Schema' : 'Materialized';
        if (self.analyticalModel.cube.dataVersionType != undefined && self.analyticalModel.cube.dataVersionType == 'Static') {
            self.dataVersionType = 'Static';
            var dateTime = new Date(self.analyticalModel.cube.dataVersion);
            var dvDate = dateTime.getUTCDate() + '-' + (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
            self.dataVersionDate = self.ngbDataConv.fromModel(dvDate);
            var endDvTime = dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + ":" + dateTime.getUTCSeconds();
            self.dataVersionTime = self.ngbTimeConv.fromModel(endDvTime);
        }
        else {
            self.dataVersionType = 'Dynamic';
        }
        if (self.analyticalModel.cube.startDataVersion) {
            var startDate = new Date(self.analyticalModel.cube.startDataVersion);
            self.startDataVersion = self.ngbDataConv.fromModel(startDate.getUTCDate() + '-' + (startDate.getUTCMonth() + 1) + '-' + startDate.getUTCFullYear());
            var startDvTime = self.ngbTimeConv.fromModel(startDate.getUTCHours() + ":" + startDate.getUTCMinutes() + ":" + startDate.getUTCSeconds());
            if (!!startDvTime.hour && !!startDvTime.minute) {
                self.startDataVersionTime = startDvTime;
            }
            else if (self.analyticalModel.cube["startDataVersionTime"]) {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(self.analyticalModel.cube["startDataVersionTime"]);
            }
            else {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(0 + ":" + 0 + ":" + 0);
            }
        }
        self.activeScreen = "mapper";
        self.selectedDataSource = event.cube.dataSourceData;
        self.selectedDataSourceId = event.cube.dataSourceId;
        self.isStarSchema ? self.loadDimensions() : null;
    };
    POCWizard.prototype.fileChange = function (event) {
        this.saveButton = false;
        this.file = event.target.files[0];
    };
    POCWizard.prototype.uploadFile = function () {
        var self = this;
        var msg = self.validator();
        if (msg != '') {
            self.callToaster(MDMService.ERROR, msg);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            var formdata1 = new FormData();
            formdata1.append('file', self.file);
            if (self.isEdit) {
                self.reUpload(formdata1);
            }
            else {
                self.newUpload(formdata1);
            }
        }
    };
    POCWizard.prototype.scanPresto = function (dataSourceId) {
        var self = this;
        self.loader = true;
        self.service.uploadDataSourceForPresto(BiUrls.NEW_ANALYTICAL_MODEL_PRESTO, dataSourceId).then(function (res) {
            self.prestoData = res.data;
            self.loader = false;
        });
    };
    POCWizard.prototype.reSyncPresto = function () {
        var _this = this;
        var self = this;
        if (!this.analyticalModel)
            return null;
        this.loader = true;
        var cubeId = this.analyticalModel.cube.refId;
        self.service.syncPrestoData(BiUrls.SYNC_ANALYTICAL_MODEL, cubeId).then(function (res) {
            if (res.success) {
                self.analyticalModel = res.data;
                self.callToaster(MDMService.SUCCESS, "Scanned cube " + _this.analyticalModel.cube.cubeCode + " successfully.");
            }
            else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(MDMService.ERROR, "Something went wrong while trying to scan changes in cube " + _this.analyticalModel.cube.cubeCode);
            }
            self.activeScreen = "mapper";
            self.resetPreviewPageDetails();
            self.cubeScreen = false;
            self.isEdit = true;
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
        this.loadDimensions();
    };
    POCWizard.prototype.selectType = function (event) {
        var self = this;
        self.isStarSchema = event.target.value == 'starschema';
    };
    POCWizard.prototype.selectFact = function (event) {
        var self = this;
        self.selectedFact = +event.target.value;
        self.prestoDimData = self.prestoData;
        if (self.isStarSchema == false) {
            self.saveButton = false;
        }
    };
    POCWizard.prototype.uploadPresto = function () {
        var self = this;
        for (var _i = 0, _a = self.prestoData; _i < _a.length; _i++) {
            var data = _a[_i];
            if (data.refId == self.selectedFact) {
                self.RecordFormatData = data;
            }
        }
        if (self.isStarSchema == true) {
            self.createStarSchemaPresto();
            self.loadDimensions();
        }
        else {
            self.createMaterializedPresto();
        }
    };
    POCWizard.prototype.createStarSchemaPresto = function () {
        var self = this;
        var DimensionData = [];
        self.AnalyticalModelData = {
            fact: self.RecordFormatData,
            dimensions: DimensionData,
            isStarSchema: true
        };
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.STARSCHEMA_PRESTO, self.AnalyticalModelData).then(function (res) {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "Data upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.service.onStartUp(BiUrls.DIMENSION + BiUrls.SEARCH + _this.selectedDataSourceId).then(function (res) {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    };
    POCWizard.prototype.createMaterializedPresto = function () {
        var self = this;
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.MATERIALIZED_PRESTO, self.RecordFormatData).then(function (res) {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "Data upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.newUpload = function (formdata1) {
        var self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.NEW_ANALYTICAL_MODEL, formdata1, self.selectedDataSource.id, false).then(function (res) {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "File upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(MDMService.ERROR, "File upload failed");
            }
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.reUpload = function (formdata1) {
        var self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.SYNC_ANALYTICAL_MODEL, formdata1, self.analyticalModel.cube.id, true).then(function (res) {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "File re-upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(MDMService.ERROR, "File re-upload failed");
            }
            self.resetPreviewPageDetails();
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.loadPreview = function (event) {
        var _this = this;
        var self = this;
        if (event) {
            self.getPreviewForDrill().then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, res];
                        case 1:
                            _a.sent();
                            self.loadTenantConfigs();
                            self.cubeScreen = false;
                            self.activeScreen = "preview";
                            return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    POCWizard.prototype.getPreviewForDrill = function () {
        var self = this;
        self.modelData = {
            page: self.pageNo, size: self.pageSize,
            recordFormatData: JSON.parse(JSON.stringify(self.analyticalModel.fact))
        };
        self.modelData.recordFormatData.recordFormatFieldData = null;
        return new Promise(function (resolve) {
            self.service.analyticalModelPreview(BiUrls.PREVIEW_ANALYTICAL_MODEL, self.modelData).then(function (res) {
                if (res.success == true) {
                    self.previewAnalyticalModel = res.data;
                    resolve('complete');
                }
                else if (res.success == false && res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                }
                else {
                    self.callToaster(MDMService.ERROR, "Failed to Load Preview");
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                }
            });
        });
    };
    POCWizard.prototype.loadTenantConfigs = function () {
        var self = this;
        return new Promise(function (resolve) {
            self.service.onStartUp(BiUrls.TENANT_CONFIG).then(function (res) {
                if (res == undefined) {
                    self.callToaster(MDMService.ERROR, 'No Tenant Configurations to load');
                    resolve('error');
                }
                self.tntConfData = res;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.callToaster(MDMService.ERROR, 'Cannot load the tenant configurations');
                    resolve('error');
                }
            });
        });
    };
    POCWizard.prototype.getPreviewPageDetails = function (event) {
        var self = this;
        self.pageNo = event.pageNo;
        self.pageSize = event.pageSize;
        self.getPreviewForDrill().then(function () {
            self.activeScreen = "preview";
        });
    };
    POCWizard.prototype.validator = function () {
        if (this.selectedDataSource == undefined || this.selectedDataSource == 'none') {
            return 'Please select Data-Source to upload a file !';
        }
        if (this.file == undefined) {
            return 'Please select a file to upload !';
        }
        var msg = this.fileValidator();
        if (msg) {
            return msg;
        }
        return '';
    };
    POCWizard.prototype.fileValidator = function () {
        if (this.file) {
            var name_1 = this.file.name.split('.');
            var ext = name_1[name_1.length - 1];
            if (this.typeList.indexOf(ext) == -1) {
                return 'Please select ' + this.typeList.map(function (a) { return a.toUpperCase(); }).join(', ') + ' type file to upload';
            }
            var maxSize = 26214400; // 25MB
            var maxSizeInMB = maxSize / 1048576;
            if (this.file.size > maxSize) {
                return 'File size should not exceed ' + maxSizeInMB + 'MB';
            }
            return false;
        }
        return 'Please select a file to upload !';
    };
    POCWizard.prototype.setMapperScreen = function (event) {
        this.editScreen = event;
        this.activeScreen = "upload";
    };
    POCWizard.prototype.next = function () {
        this.cubeScreen = false;
        this.mapperScreen = false;
        this.dimensionPage = true;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setMeasureList = function (event) {
        this.measureMap = event;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setDimensionList = function (event) {
        this.dimensionMap = event;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setDimensionAndMeasureLinkage = function () {
        var _this = this;
        this.analyticalModel.isStarSchema = this.isStarSchema;
        this.analyticalModel.cube.cubeMeasureData = [];
        this.analyticalModel.cube.cubeDimensionUsageData = [];
        this.measureMap.forEach(function (ele) { _this.analyticalModel.cube.cubeMeasureData.push(ele); });
        this.dimensionMap.forEach(function (ele) { _this.analyticalModel.cube.cubeDimensionUsageData.push(ele); });
    };
    POCWizard.prototype.prestoDimValidation = function (event) {
        this.prestoValidation = event;
    };
    POCWizard.prototype.entityOpsDimension = function (event) {
        if (this.selectedDim == null) {
            this.selectedDim = event.target.id;
        }
        else {
            this.selectedDim = null;
        }
    };
    POCWizard.prototype.editDimension = function (dim) {
        this.dimensionData = JSON.parse(JSON.stringify(dim));
        this.editDimensionPage = true;
    };
    POCWizard.prototype.onBackFromDimEdit = function () {
        this.editDimensionPage = false;
        this.selectedDim = null;
    };
    POCWizard.prototype.afterDim = function () {
        this.dimensionPage = false;
        this.editDimensionPage = false;
        this.measurePage = true;
    };
    POCWizard.prototype.setdataVersionType = function (value) {
        if (value != 'Static') {
            this.dataVersionDate = null;
            this.dataVersionTime = null;
        }
        this.dataVersionType = value;
        this.startDataVersion = null;
        this.startDataVersionTime = null;
    };
    POCWizard.prototype.saveAnalyticalModel = function () {
        var self = this;
        self.analyticalModel.isStarSchema = self.isStarSchema;
        var validate = self.cubeValidator();
        if (validate != '') {
            self.callToaster(MDMService.ERROR, validate);
            return;
        }
        var validate2 = self.dateValidator();
        if (validate2 != '') {
            self.callToaster(MDMService.ERROR, validate2);
            return;
        }
        if (!this.prestoValidation && this.isStarSchema) {
            self.callToaster(MDMService.ERROR, 'Please select the Dimension!');
            return;
        }
        self.loader = true;
        self.analyticalModel.cube["startDataVersion"] = self.startDataVersion ? Date.parse(self.ngbDataConv.toModel(self.startDataVersion)) : null;
        self.analyticalModel.cube["startDataVersionTime"] = self.startDataVersionTime ? self.ngbTimeConv.toModel(self.startDataVersionTime) : null;
        self.analyticalModel.cube["dataVersion"] = self.dataVersionDate ? Date.parse(self.ngbDataConv.toModel(self.dataVersionDate)) : null;
        self.analyticalModel.cube["dataVersionTime"] = self.dataVersionTime ? self.ngbTimeConv.toModel(self.dataVersionTime) : null;
        if (self.dataVersionType) {
            self.analyticalModel.cube.dataVersionType = self.dataVersionType;
        }
        self.loader = true;
        if (self.analyticalModel.cube.id != undefined) {
            self.service.saveFileForDesigner(BiUrls.UPDATE_ANALYTICAL_MODEL, self.analyticalModel).then(function (res) {
                if (res.success) {
                    self.callToaster(MDMService.SUCCESS, "Changes Saved Successfully");
                }
                else if (res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                }
                else if (res.errorMessage != undefined) {
                    self.callToaster(MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        }
        else {
            self.service.saveFileForDesigner(BiUrls.SAVE_ANALYTICAL_MODEL, self.analyticalModel).then(function (res) {
                self.setPageNumberAfterCreatingNew();
                if (res.success) {
                    self.callToaster(MDMService.SUCCESS, "Analytical Model Saved");
                }
                else if (res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                }
                else if (res.errorMessage != undefined) {
                    self.callToaster(MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        }
    };
    POCWizard.prototype.setPageNumberAfterCreatingNew = function () {
        var self = this;
        if (self.service.referenceLastPage) {
            self.service.referencePage = self.service.referenceLastPage - 1;
        }
        self.service.referenceLastPage = null;
    };
    POCWizard.prototype.afterSave = function () {
        var self = this;
        self.cubeScreen = true;
        self.editScreen = false;
        self.loader = false;
        self.isEdit = false;
        self.analyticalModel = null;
        self.prestoData = null;
        self.inMesEdit = false;
        self.previewAnalyticalModel = null;
        self.startDataVersion = null;
    };
    POCWizard.prototype.afterEditDim = function (event) {
        var self = this;
        self.analyticalModel.cube.cubeDimensionUsageData.forEach(function (dim) {
            if (dim.dimensionId == event.refId) {
                dim.dimensionData = event;
            }
        });
        this.editDimensionPage = false;
        this.selectedDim = null;
    };
    POCWizard.prototype.getFormulaMes = function (measureId) {
        var _this = this;
        this.analyticalModel.cube.cubeMeasureData.forEach(function (mesData) {
            if (mesData.measureId == measureId && mesData.recordFormatFieldId == null) {
                _this.isFormulaMeasure = true;
                return;
            }
        });
    };
    POCWizard.prototype.editMeasure = function (measure) {
        this.measureData = JSON.parse(JSON.stringify(measure));
        this.editMeasurePage = true;
        this.isnewFormulaMeasure = false;
        if (!this.isFormulaMeasure) {
            this.getFormulaMes(measure.refId);
        }
    };
    POCWizard.prototype.afterEditMeasure = function (event) {
        var self = this;
        if (!self.isnewFormulaMeasure) {
            self.analyticalModel.cube.cubeMeasureData.forEach(function (measure) {
                if (measure.measureId == event.refId) {
                    measure.measureData = event;
                }
            });
        }
        else {
            self.constructMeasureForFormula(event);
        }
        self.measureData = JSON.parse(JSON.stringify(event));
        self.inMesEdit = true;
        self.isFormulaMeasure = false;
        self.editMeasurePage = false;
        self.selectedMeasureId = null;
    };
    POCWizard.prototype.entityOpsMeasure = function (event) {
        if (this.selectedMeasureId == null) {
            this.selectedMeasureId = event.target.id;
            this.getFormulaMes(this.selectedMeasureId);
        }
        else {
            this.selectedMeasureId = null;
        }
    };
    POCWizard.prototype.onBackFromMeasureEdit = function () {
        this.editMeasurePage = false;
        this.selectedMeasureId = null;
        this.isFormulaMeasure = false;
        this.isnewFormulaMeasure = false;
        this.inMesEdit = false;
    };
    POCWizard.prototype.cancelDesigner = function () {
        if (this.cubeScreen) {
            this.childComponent.onBack();
        }
        this.selectedDataSource = null;
        this.cubeScreen = true;
        this.editScreen = false;
        this.uploadScreen = false;
        this.dimensionPage = false;
        this.measurePage = false;
        this.analyticalModel = null;
        this.inMesEdit = false;
        this.isEdit = false;
        this.file = null;
        this.isStarSchema = null;
        this.selectedFact = null;
        this.prestoData = null;
        this.startDataVersion = null;
        this.resetPreviewPageDetails();
    };
    POCWizard.prototype.resetPreviewPageDetails = function () {
        this.pageNo = 0;
        this.pageSize = 10;
        this.previewAnalyticalModel = null;
    };
    POCWizard.prototype.createNew = function () {
        this.selectedDataSource = null;
        this.childComponent.onBack();
        this.activeScreen = 'upload';
        this.cubeScreen = false;
    };
    POCWizard.prototype.beforeChange = function (event) {
        this.activeScreen == event.nextId;
        this.editDimensionPage = false;
        this.editMeasurePage = false;
        this.selectedDim = null;
        this.selectedMeasureId = null;
        this.file = null;
    };
    POCWizard.prototype.cubeValidator = function () {
        if (this.analyticalModel.cube.name != undefined && this.analyticalModel.cube.name.trim() == '') {
            return 'Please enter the name for Cube!';
        }
        return '';
    };
    POCWizard.prototype.addFormulaMeasure = function () {
        this.isFormulaMeasure = true;
        this.isnewFormulaMeasure = true;
        this.isEdit = false;
        var measure = new MeasureData();
        measure.targetType = 'max';
        measure.aggregator = 'sum';
        this.editMeasure(measure);
        this.isnewFormulaMeasure = true;
    };
    POCWizard.prototype.constructMeasureForFormula = function (measure) {
        var cubeMeasureData = new CubeMeasure();
        cubeMeasureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.name = measure.displayName;
        cubeMeasureData.deleted = false;
        cubeMeasureData.measureData = measure;
        cubeMeasureData.measureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.measureId = cubeMeasureData.measureData.refId;
        cubeMeasureData.measureData.targetType = measure.targetType;
        cubeMeasureData.measureData.aggregator = measure.aggregator;
        cubeMeasureData.measureData.deleted = false;
        cubeMeasureData.measureData.measureStatusIndicator = [];
        cubeMeasureData.measureData.measureTarget = [];
        cubeMeasureData.measureData.formulaExpression = measure.formulaExpression;
        this.analyticalModel.cube.cubeMeasureData.push(cubeMeasureData);
        this.isFormulaMeasure = false;
    };
    POCWizard.prototype.closeDropDown = function (event) {
        this.selectedMeasureId = null;
        this.selectedDim = null;
        this.isFormulaMeasure = false;
    };
    POCWizard.prototype.setFormulaList = function (event) {
        var _this = this;
        event.forEach(function (ele) {
            _this.analyticalModel.cube.cubeMeasureData.push(ele);
        });
    };
    POCWizard.prototype.removeMeasure = function (measure) {
        var r = confirm('Are you sure you want to remove the measure ' + measure.name + ' ?');
        if (r == true) {
            var index = this.analyticalModel.cube.cubeMeasureData.indexOf(measure);
            this.analyticalModel.cube.cubeMeasureData.splice(index, 1);
        }
    };
    POCWizard.prototype.clearCache = function () {
        var self = this;
        self.service.clearCache('ads/clearDataCache').then(function (res) {
            if (res.success) {
                self.toaster.showSuccess("Cache cleared successfully!");
            }
            else {
                self.toaster.showError("Unable To Clear Cache!");
            }
        });
    };
    POCWizard.prototype.dateValidator = function () {
        var self = this;
        if (this.startDataVersion && this.dataVersionDate) {
            var startDateMillisecond = (new Date(self.startDataVersion.year + "-" +
                self.startDataVersion.month + "-" + self.startDataVersion.day + " " +
                self.startDataVersionTime.hour + ":" + self.startDataVersionTime.minute).getTime());
            var endDateMillisecond = (new Date(self.dataVersionDate.year + "-" +
                self.dataVersionDate.month + "-" + self.dataVersionDate.day + " " +
                self.dataVersionTime.hour + ":" + self.dataVersionTime.minute).getTime());
            if (startDateMillisecond > endDateMillisecond) {
                return 'Start-Date cannot be greater than End-Date !';
            }
        }
        return '';
    };
    POCWizard.prototype.setStartDvTime = function (time) {
        this.startDataVersionTime = time;
    };
    POCWizard.prototype.setDvTime = function (time) {
        this.dataVersionTime = time;
    };
    POCWizard.prototype.clearStartDate = function () {
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
    };
    return POCWizard;
}());
export { POCWizard };



// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/pocWizard.component.ts.pre-build-optimizer.js